var map = {
	"./AssessmentReport.svg": 336,
	"./Bangladesh.svg": 337,
	"./Daily.svg": 338,
	"./EnrolledPatientReport.svg": 339,
	"./Failed.svg": 88,
	"./Ghana.svg": 340,
	"./Info-blue.svg": 214,
	"./Info-green.svg": 213,
	"./Kenya.svg": 341,
	"./MOH.svg": 342,
	"./PatientDuplicateReport.svg": 343,
	"./Pending.svg": 215,
	"./Permanent.svg": 344,
	"./Presc.svg": 345,
	"./ScreenedReport.svg": 346,
	"./Sierra Leone.svg": 347,
	"./Tanzania.svg": 348,
	"./US.svg": 349,
	"./app-logo.svg": 72,
	"./arrow-right-small.svg": 350,
	"./assignQuickSightUser.svg": 216,
	"./avatar-o.svg": 351,
	"./bin.svg": 217,
	"./caret-down-grey.svg": 211,
	"./caret-down-white.svg": 352,
	"./checkbox-disabled.svg": 218,
	"./checkbox-empty.svg": 169,
	"./checkbox.svg": 170,
	"./close.svg": 219,
	"./download.svg": 126,
	"./dropdown.svg": 220,
	"./edit.svg": 127,
	"./hidePass.svg": 111,
	"./home.svg": 221,
	"./info-grey.svg": 353,
	"./info-orange.svg": 212,
	"./insights.svg": 222,
	"./no-icon.svg": 247,
	"./plus.svg": 223,
	"./power-switch.svg": 210,
	"./quickSightUser.svg": 224,
	"./reports.svg": 225,
	"./reset.svg": 226,
	"./search.svg": 227,
	"./send-disabled.svg": 228,
	"./send.svg": 229,
	"./showPass.svg": 80,
	"./success-blue.svg": 128,
	"./success-green.svg": 230,
	"./tick.svg": 231,
	"./user-role-assigned.svg": 232,
	"./user-role-not-assigned.svg": 125,
	"./warning.svg": 233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 246;